import React, { useEffect, useState } from 'react';
import Button from "b2b-ui-components-lib/lib/components/button";
import RadioGroup from "b2b-ui-components-lib/lib/components/radioGroup";
import {stopBackgroundScrolling} from "../../../common/utils/app.utils";

const ContractSelectModal = (props) =>{
    let{selectedPlan,showPopup,contractOptions,selectedcontractOption, onContractChange,popupCloseHandler,okClickHandler,
        //  ipAttributeType, changeIpAttributeType
        }=props;
    const [priceLabel, setPriceLabel] = useState([]);
    const [planPriod, setPlanPriod] = useState(selectedcontractOption);
    const closeCustomModal = () =>{
        stopBackgroundScrolling(false);
        popupCloseHandler();
    }
    const submitCustomModal = ()=>{
        onContractChange(planPriod)
        stopBackgroundScrolling(false);
        okClickHandler();
    }
    const setPlanPriodValue = value =>{
        setPlanPriod(value)
    }
    useEffect(() => {
        stopBackgroundScrolling(true);
        let arcAmount =selectedPlan && selectedPlan.price && selectedPlan.price.amount ? selectedPlan.price.amount : 0;
        let octAmount =selectedPlan && selectedPlan.price && selectedPlan.price.otc ? selectedPlan.price.otc : 0;
        let getContractOptions = contractOptions;
        let modifyContractOptions=[];
        let totalAmount=null;
        getContractOptions && getContractOptions.length > 0 && getContractOptions.map((contractOption, index) =>{
                let copyObject={};
                totalAmount=(arcAmount*contractOption.value) + octAmount;
                copyObject.displayName=contractOption.displayName+': ₹'+ totalAmount;
                copyObject.id=contractOption.id;
                copyObject.value=contractOption.value;
                if(selectedcontractOption && selectedcontractOption.value === contractOption.value){
                    copyObject.checked=true;
                } else {
                    delete copyObject.checked;
                }
                modifyContractOptions.push(copyObject);
        });

        setPriceLabel(modifyContractOptions)
    }, []);

    // const confirmPlanChange = () => {
    //     changeIpAttributeType({
    //         ipAttributeType: false,
    //         speed: 0
    //     })
    // }

    // const closePlanChangeModal = () =>{
    //     stopBackgroundScrolling(false);
    //     popupCloseHandler(true);
    //     console.log('cancel')
    // }
    
    return(
        <React.Fragment>
            <div className={`modal-custom ${showPopup ? "open" : ""}`}>
                <div className="modal_dialog contract_modal">
                    {/* { ipAttributeType ?
                        <div className="modal_content">
                            <div className="modal_body">
                                <div className="heading">{PLAN_CONFIGURATION_MSG.CHANGE_CONFIGURATION}</div>
                                <div className="next_step">
                                    <Button onClick={closePlanChangeModal} variant="outlinebtn">Cancel</Button>
                                    <Button onClick={confirmPlanChange} variant="activebtn">Yes</Button>
                                </div>
                            </div>
                        </div>
                        : */}
                        <div className="modal_content">
                            <div className="modal_header">
                                <h5>Choose contract period</h5>
                            </div>
                            <div className="modal_body">
                                <div className="choose_items">
                                    <RadioGroup
                                        options={priceLabel}
                                        value={planPriod}
                                        onChange={setPlanPriodValue}
                                    />
                                </div>
                                <div className="plan_condition">*All cost are excluding taxes.</div>
                                <div className="next_step">
                                    <Button onClick={closeCustomModal} variant="outlinebtn">Cancel</Button>
                                    <Button onClick={submitCustomModal} variant="activebtn">Save</Button>
                                </div>
                            </div>
                        </div>
                    {/* } */}
                </div>
            </div>
        </React.Fragment>
    )
}

export default ContractSelectModal;
